import React from "react";
import verifiedIcon from "src/images/verified.svg";
import { SocialProfileFlags, SocialProfileStatus } from "../../../types";

interface SocialProfileWithIconKey {
  icon: string;
  socialId: string | null;
  socialProvider: string;
  socialUrl: string;
  socialUsername: string;
  status: SocialProfileStatus;
  flags: SocialProfileFlags[];
}

interface ApiPairedIconProps {
  item: SocialProfileWithIconKey;
}

export function ApiPairedIcon({ item }: ApiPairedIconProps) {
  if (item?.flags?.includes(SocialProfileFlags.ApiPaired)) {
    return (
      <div className="verified-badge">
        <img src={verifiedIcon} alt="Verified" />
      </div>
    );
  }

  return null;
}
